<template>
  <section class="mb-5">
    <div class="mt-2 mb-4 border-bottom">
      <h2 class="display-4">Die Reparaturarten</h2>
      <h5>
        <strong>Insgesamt</strong>
        <span class="text-primary px-2">{{ totalColumns }}</span
        >Services auf <span class="text-primary px-2">{{ servicePages }}</span
        >Seite/n
      </h5>
    </div>
    <span class="me-2">Neu Reparatur hinzufügen:</span>
    <button
      type="button"
      title="Neu Gerät hinzufügen"
      class="btn btn-primary me-2"
      data-bs-toggle="modal"
      data-bs-target="#modalServices"
    >
      <i class="fa-solid fa-sm fa-plus"></i>
    </button>
    <!-- Modal Service -->
    <div
      class="modal fade"
      id="modalServices"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="modalServicesLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalServicesLabel">Neu Reparatur hinzufügen</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col mb-3">
                <label for="typeServices" class="form-label"
                  >Reparaturtyp</label>
                <select
                  v-if="typeservice"
                  id="typeServices"
                  v-model="data.servicetype_key"
                  class="form-select"
                  aria-label="Default select example"
                >
                  <option
                    v-for="(item, index) in typeservice"
                    :key="index"
                    :value="item.uid"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class="col mb-3">
                <label for="devices" class="form-label">Für Gerät</label>
                <select
                  v-if="devices"
                  id="devices"
                  v-model="data.device_key"
                  class="form-select"
                  aria-label="Default select example"
                >
                  <option
                    v-for="(item, index) in devices"
                    :key="index"
                    :value="item.uid"
                  >
                    {{ item.marker }}
                    {{ item.series }}
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="mb-3">
              <label for="title" class="form-label">Titel</label>
              <input
                type="text"
                class="form-control"
                id="title"
                v-model="data.title"
                placeholder="Apple"
              />
            </div>
            <div class="mb-3">
              <label for="price" class="form-label">Preis</label>
              <input
                type="number"
                class="form-control"
                id="price"
                v-model="data.price"
                placeholder="S"
              />
            </div>
            <div class="mb-3">
              <label for="description" class="form-label">Beschreibung</label>
              <textarea
                class="form-control"
                id="description"
                v-model="data.description"
                rows="3"
              ></textarea>
            </div>
            <div class="mb-3">
              <label for="state" class="form-label">Status</label>
              <select
                id="state"
                v-model="data.state"
                class="form-select"
                aria-label="Default select example"
              >
                <option value="0">Nicht verfügbar</option>
                <option value="1">verfügbar</option>
              </select>
            </div>
          </div>
          <div class="modal-footer" data-bs-dismiss="modal">
            <button type="button" class="btn btn-link">Abbrechen</button>
            <button
              type="button"
              class="btn btn-primary"
              @click="addOrEditService"
            >
              Speichern
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Services cards -->
    <div v-if="services" class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-4 my-2">
      <div v-for="(item, index) in services" :key="index" class="col">
        <div class="card bg-light">
          <div class="card-header bg-dark text-white small d-flex">
            <span><i class="fa-solid fa-sm fa-wrench text-primary"></i></span>
            <span class="ms-auto">{{ item.price }}€</span>
          </div>

          <div class="card-body">
            <h5 class="card-title text-primary mb-3">{{ item.title }}</h5>
            <p class="card-text">{{ item.description }}</p>
          </div>
          <div class="card-body py-1 mt-auto">
            <select class="form-select-sm" v-model="item.state" aria-label="Default select example">
              <option value="0">Nicht verfügbar</option>
              <option value="1">verfügbar</option>
            </select>
            <div class="btn-group my-2">
              <button
                class="btn btn-sm btn-outline-primary"
                title="Speichern"
                @click="changeServiceState(item)"
                >
                <i class="fa-solid fa-sm fa-floppy-disk"></i>
              </button>
              <button
                type="button"
                @click="data = item"
                class="btn btn-sm btn-outline-success"
                title="Bearbeiten"
                data-bs-toggle="modal"
                data-bs-target="#modalServices"
                >
                <i class="fa-solid fa-sm fa-pen-to-square"></i>
              </button>
              <button
              class="btn btn-sm btn-outline-dark"
              title="Löschen"
              @click="deleteService(item, index)"
              >
                <i class="fa-solid fa-sm fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <table v-else class="table">
      <tbody>
        <tr v-for="(item, index) in 5" :key="index">
          <th scope="row">
            <p class="placeholder-glow">
              <span class="placeholder col-12"></span>
            </p>
          </th>
          <td>
            <p class="placeholder-glow">
              <span class="placeholder col-12"></span>
            </p>
          </td>
          <td>
            <p class="placeholder-glow">
              <span class="placeholder col-12"></span>
            </p>
          </td>
          <td>
            <p class="placeholder-glow">
              <span class="placeholder col-12"></span>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex align-items-center justify-content-center my-4">
      <ul class="pagination">
        <li class="page-item" v-for="page in servicePages" :key="page">
          <button class="page-link" @click="openPage(page)">{{ page }}</button>
        </li>
      </ul>
    </div>
    <!-- Reparaturtyp -->
    <div class="border-top pt-3 mv-3">
      <div class="my-2">
        <h2 class="mb-3 text-primary">Reparaturtyp</h2>
        <span class="me-2">Neu Reparaturtyp hinzufügen:</span>
        <button
          type="button"
          class="btn btn-primary me-2"
          data-bs-toggle="modal"
          data-bs-target="#modalTypeServices"
          title="Reparaturtyp hinzufügen"
        >
          <i class="fa-solid fa-sm fa-plus"></i>
        </button>
      </div>

      <!-- Modal Type Service -->
      <div
        class="modal fade"
        id="modalTypeServices"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="modalTypeServicesLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalTypeServicesLabel">
                Neu Reparaturtyp hinzufügen
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="name" class="form-label">Name dem Typ</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  v-model="type.name"
                  placeholder="Display, Akku Tauschen ..."
                  required
                />
              </div>
              <div class="mb-3">
                <input
                  class="form-file-control"
                  type="file"
                  @change="handleFiles"
                  id="formFile"
                />
              </div>
            </div>
            <div class="modal-footer" data-bs-dismiss="modal">
              <button type="button" class="btn btn-link">Abbrechen</button>
              <button
                type="button"
                class="btn btn-outline-primary"
                @click="addOrEditTypeService"
              >
                Speichern
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--List of types-->
      <ul class="list-group my-2 col-12 col-md-8">
        <li v-for="(item, index) in typeservice" :key="index" class="list-group-item d-flex align-items-center">
          <img
            :src="$store.state.config.endpoint + item.thumbnail"
            class=""
            height="50px"
            :alt="item.name"
          />
          <span class="ms-2">{{ item.name }}</span>
          <span class="badge ms-auto">
            <button
              class="btn btn-outline-dark"
              @click="deleteTypeService(item, index)"
            >
              <i class="fa-solid fa-sm fa-trash"></i>
            </button>
          </span>
        </li>
      </ul>
    </div>

  </section>
</template>

<script>
export default {
  name: "Services",

  data() {
    return {
      perPage: 30,
      totalColumns: 0,
      lastColumns: 0,
      servicePages: 0,
      services: undefined,
      devices: undefined,
      typeservice: undefined,
      data: {
        servicetype_key: undefined,
        device_key: undefined,
        title: "",
        price: 0,
        description: "",
        state: 1,
      },
      type: {
        name: "",
        thumbnail: undefined,
      },
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadServices();
      this.loadTypesServiceAndDevices();
    });
  },

  watch: {},

  methods: {
    loadTypesServiceAndDevices() {
      this.$store.state.modules.api
        .loadTypesServiceAndDevices()
        .then((resp) => {
          console.log(resp);
          if (resp.status == 200) {
            this.devices = resp.data.devices;
            this.typeservice = resp.data.typeservice;
          }
          this.$store.state.utils.loaded = true;
        })
        .catch((err) => {
          this.$store.state.utils.loaded = true;
        });
    },

    loadServices() {
      this.$store.state.modules.api
        .loadServices(this.perPage, this.lastColumns)
        .then((resp) => {
          console.log(resp);
          if (resp.status == 200) {
            this.services = resp.data.units;
            this.totalColumns = resp.data.total;
            this.servicePages = Math.ceil(this.totalColumns / this.perPage);
          }
          this.$store.state.utils.loaded = true;
        })
        .catch((err) => {
          this.$store.state.utils.loaded = true;
        });
    },

    openPage(num) {
      this.lastColumns = (num - 1) * this.perPage;
      this.loadServices();
    },

    handleFiles(event) {
      if (event.target.files[0].size < 10000000) {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
          this.$store.state.modules.api
            .uploadTypeServiceThumbnail(reader.result)
            .then((resp) => {
              if (resp.status == 200) {
                this.type.thumbnail = resp.data.thumbnail;
                console.log(this.type.thumbnail);
              } else {
                this.$store.state.utils.setNewNotifications(
                  {
                    type: "warning",
                    title: "Fehlermeldung",
                    message: "Etwas ist schief gelaufen. :(",
                  },
                  2500
                );
              }
            })
            .catch((err) => {
              console.error(err);
            });
        };
        reader.onerror = (error) => {
          console.error("Error: ", error);
        };
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "info",
            title: "Bildgröße",
            message: "Das maximale Bildgröße beträgt 10MB",
          },
          2500
        );
      }
    },

    addOrEditTypeService() {
      this.$store.state.modules.api
        .addOrEditTypeService(this.type)
        .then((resp) => {
          if (resp.status == 200) {
            if (resp.data.new) {
              this.typeservice.push(resp.data.unit);
            }

            this.type = {
              name: "",
              thumbnail: undefined,
            };

            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                title: "Neue Reparatur",
                message: "Die Reparatur wurde erfolgreich hinzugefügt",
              },
              2500
            );
          } else {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                title: "Fehlermeldung",
                message: "Etwas ist schief gelaufen. :(",
              },
              2500
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    addOrEditService() {
      console.log(this.data);
      this.$store.state.modules.api
        .addOrEditService(this.data)
        .then((resp) => {
          if (resp.status == 200) {
            if (resp.data.new) {
              this.services.push(resp.data.unit);
            }

            this.data = {
              servicetype_key: undefined,
              device_key: undefined,
              title: "",
              price: 0,
              description: "",
              state: 1,
            };

            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                title: "Neue Reparatur",
                message: "Die Reparatur wurde erfolgreich hinzugefügt",
              },
              2500
            );
          } else {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                title: "Fehlermeldung",
                message: "Etwas ist schief gelaufen. :(",
              },
              2500
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    changeServiceState(item) {
      this.$store.state.modules.api
        .changeServiceState(item)
        .then((resp) => {
          // console.log(resp);
          if (resp.status == 200) {
            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                title: "Reparaturstatus",
                message: "Status wurde zu " + item.state + " geändert",
              },
              2500
            );
          }
        })
        .catch((err) => {});
    },

    deleteService(item, index) {
      this.$store.state.modules.api
        .deleteService(item)
        .then((resp) => {
          // console.log(resp);
          if (resp.status == 200) {
            this.services.splice(index, 1);

            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                title: "Löschen",
                message: "Die Reparatur wurde erfolgreich entfernt!",
              },
              2500
            );
          }
        })
        .catch((err) => {});
    },

    deleteTypeService(item, index) {
      this.$store.state.modules.api
        .deleteTypeService(item)
        .then((resp) => {
          // console.log(resp);
          if (resp.status == 200) {
            this.typeservice.splice(index, 1);
            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                title: "Löschen",
                message: "Die Reparatur wurde erfolgreich entfernt!",
              },
              2500
            );
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
